"use client"

import { DiamondPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DiamondPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DiamondPlusIcon = component(Icon)({ as: DiamondPlus })
